import { IconButton, Modal } from "@mui/material";
import { style } from "@mui/system";
import classNames from "classnames";

import { IDialogModalProps } from "../models";
import styles from "./styles.module.scss";

interface Props extends IDialogModalProps {
  className?: string;
}

export const DialogModal = ({
  open,
  handleClose,
  children,
  title,
  className = "",
}: Props): JSX.Element => {
  return (
    <Modal open={open} onClose={handleClose} className={styles.modalContainer}>
      <div
        className={classNames(
          styles["card"],
          styles["modal_body"],
          className && className
        )}>
        <div className={styles.header}>
          <div onClick={handleClose} className={styles.close_icon}>
            <img alt="close" src={"/assets/images/svg/closeDark.svg"} />
          </div>
          <h1>{title}</h1>
        </div>
        {children}
      </div>
    </Modal>
  );
};
